import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import React from 'react';
import {
    Controlled_AutocompleteMultiSelectReferenceTextField,
} from './Controlled_AutocompleteMultiSelectReferenceTextField';
import {
    useVerificationMetricActions,
} from '../../../../resource/resources/artifacts/verification_metric/verificationMetricResource';

export const Controlled_VerificationMetricTextField= ({ objectIds, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectIds: string[] | undefined;
    projectVersionId: string | undefined | null;
    onChange?: (id: string[] | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation?: PropertyValidationInformation;
}) => {

    const verificationMetricActions = useVerificationMetricActions()
    const verificationMetricsQuery = verificationMetricActions.useGetAllResources(projectVersionId);

    return (
        <Controlled_AutocompleteMultiSelectReferenceTextField
            idValues={objectIds}
            readOnly={readOnly}
            onChange={onChange}
            // propertyValidation={propertyValidation}
            // propertyDetails={noLabel ? undefined : propertyDetails}
            propertyValidation={null}
            propertyDetails={undefined}
            query={verificationMetricsQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
        />
    );
};